import { combineReducers } from 'redux';

import { assetVerificationReducer as assetVerification } from 'redpoints-front-asset-verification/AssetVerification';
import { newIncidentReducer as newIncident } from 'redpoints-front-new-incident/NewIncident';

const detection = combineReducers({
  assetVerification,
  newIncident,
});

export default detection;
